module.exports = __webpack_public_path__ + "static/media/HeaderLogo.c6c31785.svg";